import React, { useEffect, useState } from 'react'
import { CountWrap } from './styles'
import { CountProps } from './types'

const Count = ({value, increaseFlag, maxCount, minCount = 0, handleChangeCount}: CountProps) => {

  const [count, setCount] = useState(minCount)
  const handleChange = (i: number) => {
    const newValue = Math.max(minCount, Math.min(i, maxCount))
    setCount(newValue);
  }

  const handleMinus = () => {
    count > minCount && setCount(count - 1)
  }

  const handlePlus = () => {
    increaseFlag && count < maxCount && setCount(count + 1)
  }


  useEffect(() => {
    handleChangeCount(count)
  }, [count])

  useEffect(() => {
    if (!increaseFlag) {
      setCount(value)
      return
    }

    if (maxCount <= 0) {
      setCount(0)
      return
    }

    const nextCount = value >= minCount ? value : minCount
    setCount(Math.min(nextCount, maxCount))
  }, [increaseFlag, maxCount, minCount, value])

  return (
    <CountWrap>
      <button
        type='button'
        onClick={handleMinus}
      >
        -
      </button>
      <input
        type="number"
        value={count}
        onChange={(e) => handleChange(Number(e.target.value))}
        max={maxCount}
      />
      <button
        type='button'
        onClick={handlePlus}
      >
        +
      </button>
    </CountWrap>
  )
}

export default Count
